import './scss/style.scss';
import React, { useLayoutEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import allRoutes from './components/routes';
import { getSubdomain } from './helpers/utils';

const App = () => {
  useLayoutEffect(() => {
    const partnerSlug = getSubdomain();
    if (partnerSlug) {
      const bodyClassName = {
        hazelvalley: 'th',
        bridgehomes: 'bh',
      };

      if (document?.body) {
        document.body.className = bodyClassName?.[partnerSlug] || '';
      }
      const shortcutIconTag = document?.getElementById('shortcut-icon-tag');
      if (shortcutIconTag) {
        shortcutIconTag.href = `${process.env.PUBLIC_URL}/favicons/${partnerSlug}/icon-512.png`;
      }
      const appleTouchIconTag = document?.getElementById('apple-touch-icon-tag');
      if (appleTouchIconTag) {
        appleTouchIconTag.href = `${process.env.PUBLIC_URL}/favicons/${partnerSlug}/icon-192.png`;
      }
      const manifestTag = document?.getElementById('manifest-tag');
      if (manifestTag) {
        manifestTag.href = `${process.env.PUBLIC_URL}/favicons/${partnerSlug}/manifest.json`;
      }
    }
  }, []);

  const router = createBrowserRouter(allRoutes);
  return <RouterProvider router={router} />;
};

export default App;
